module.exports = "/assets/data/3422539efd6c4f62321b730810841719-GU9.data.json";